import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import type { SessionDto, StartSessionInput } from '../schemas/sessionSchemas';
import { sessionKeys } from './sessionKeys';

export function useStartSession() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (body: StartSessionInput) =>
      apiClient.post(`api/v1/t/${tenantId}/sessions`, { json: body }).json<SessionDto>(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: sessionKeys.lists() });
    },
  });
}
